import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import { Visibility as ViewIcon, Edit as EditIcon } from "@material-ui/icons";
import {
  withModulesManager,
  withHistory,
  formatMessage,
  formatMessageWithValues,
  formatDateFromISO,
  Searcher,
} from "@openimis/fe-core";
import { fetchInsureeEnrollments } from "../actions";
import EnrollmentFilter from "./EnrollmentFilter";
import EnrollmentStatusBadge from "./common/EnrollmentStatusBadge";
import {
  DEFAULT_ENROLLMENT_FILTERS,
  DEFAULT_PAGE_SIZE,
  ROWS_PER_PAGE_OPTIONS,
} from "../constants";
import { filtersToQueryParams, enrollmentRowIdentifier } from "../utils/searcher";
import {
  normalizeInsureeData,
  formatDisplayValue,
} from "../utils/enrollmentData";

class InsureeEnrollmentSearcher extends Component {
  constructor(props) {
    super(props);
    this.rowsPerPageOptions = props.modulesManager.getConf(
      "fe-enrollment",
      "insureeEnrollmentFilter.rowsPerPageOptions",
      ROWS_PER_PAGE_OPTIONS
    );
    this.defaultPageSize = props.modulesManager.getConf(
      "fe-enrollment",
      "insureeEnrollmentFilter.defaultPageSize",
      DEFAULT_PAGE_SIZE
    );
  }

  fetch = (prms) => {
    this.props.fetchInsureeEnrollments(this.props.modulesManager, prms);
  };

  openEdit = (e) => {
    if (this.props.history) {
      this.props.history.push(`/enrollment/insuree/${e.uuid}/edit`);
    }
  };

  headers = () => [
    "insureeEnrollment.chfId",
    "insureeEnrollment.insuree",
    "insureeEnrollment.dob",
    "insureeEnrollment.phone",
    "insureeEnrollment.status",
    "insureeEnrollment.enrollmentDate",
    "",
  ];

  sorts = () => [
    null,
    null,
    null,
    null,
    ["status", true],
    ["dateCreated", false],
    null,
  ];

  itemFormatters = () => {
    const { modulesManager, intl, onDoubleClick } = this.props;
    return [
      (e) => formatDisplayValue(normalizeInsureeData(e.insureeData).chfId),
      (e) => {
        const d = normalizeInsureeData(e.insureeData);
        return `${formatDisplayValue(d.lastName)}, ${formatDisplayValue(
          d.otherNames
        )}`;
      },
      (e) =>
        formatDateFromISO(
          modulesManager,
          intl,
          normalizeInsureeData(e.insureeData).dob
        ) || "-",
      (e) => formatDisplayValue(normalizeInsureeData(e.insureeData).phone),
      (e) => <EnrollmentStatusBadge status={e.status || "DRAFT"} size="small" />,
      (e) => formatDateFromISO(modulesManager, intl, e.dateCreated) || "-",
      (e) => (
        <>
          <Tooltip title={formatMessage(intl, "enrollment", "general.view") || "View"}>
            <IconButton
              size="small"
              onClick={(ev) => {
                ev.stopPropagation();
                onDoubleClick && onDoubleClick(e);
              }}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {e.status === "DRAFT" && (
            <Tooltip title={formatMessage(intl, "enrollment", "general.edit") || "Edit"}>
              <IconButton
                size="small"
                onClick={(ev) => {
                  ev.stopPropagation();
                  this.openEdit(e);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    ];
  };

  render() {
    const {
      intl,
      insureeEnrollments,
      insureeEnrollmentsPageInfo,
      fetchingInsureeEnrollments,
      fetchedInsureeEnrollments,
      errorInsureeEnrollments,
      cacheFiltersKey,
      onDoubleClick,
    } = this.props;

    const totalCount =
      insureeEnrollmentsPageInfo?.totalCount ?? insureeEnrollments?.length ?? 0;

    return (
      <Fragment>
        <Searcher
          module="enrollment"
          cacheFiltersKey={cacheFiltersKey}
          FilterPane={EnrollmentFilter}
          items={insureeEnrollments}
          itemsPageInfo={{
            ...insureeEnrollmentsPageInfo,
            totalCount,
          }}
          fetchingItems={fetchingInsureeEnrollments}
          fetchedItems={fetchedInsureeEnrollments}
          errorItems={errorInsureeEnrollments}
          tableTitle={formatMessageWithValues(
            intl,
            "enrollment",
            "insureeEnrollment.searcher.results",
            { count: totalCount.toLocaleString() }
          )}
          rowsPerPageOptions={this.rowsPerPageOptions}
          defaultPageSize={this.defaultPageSize}
          defaultFilters={DEFAULT_ENROLLMENT_FILTERS}
          defaultOrderBy="-dateCreated"
          fetch={this.fetch}
          rowIdentifier={enrollmentRowIdentifier}
          filtersToQueryParams={filtersToQueryParams}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          sorts={this.sorts}
          onDoubleClick={(i) => onDoubleClick && onDoubleClick(i)}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  insureeEnrollments: state.enrollment?.insureeEnrollments || [],
  insureeEnrollmentsPageInfo: state.enrollment?.insureeEnrollmentsPageInfo || {},
  fetchingInsureeEnrollments: state.enrollment?.fetchingInsureeEnrollments,
  fetchedInsureeEnrollments: state.enrollment?.fetchedInsureeEnrollments,
  errorInsureeEnrollments: state.enrollment?.errorInsureeEnrollments,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchInsureeEnrollments }, dispatch);

export default withModulesManager(
  withHistory(
    connect(mapStateToProps, mapDispatchToProps)(injectIntl(InsureeEnrollmentSearcher))
  )
);
